import { Fragment } from "react";
import { CaretRight } from "@phosphor-icons/react";

// Reusable, design-system workflow stepper for the (dark charcoal) dashboard.
// Presentation-only: `steps` = [{ label, icon? }]; optional activeIndex highlights progress.
export default function WorkflowSteps({ steps = [], activeIndex = -1, testId = "workflow-steps", className = "" }) {
  return (
    <div data-testid={testId} className={`rounded-2xl border border-white/10 bg-white/[0.03] p-4 sm:p-5 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:flex-wrap gap-3 sm:gap-0">
        {steps.map((s, i) => {
          const done = activeIndex > i;
          const active = activeIndex === i;
          const Icon = s.icon;
          return (
            <Fragment key={s.label}>
              <div className="group flex items-center gap-2.5 sm:flex-1 sm:flex-col sm:gap-2 sm:text-center" data-testid={`${testId}-step-${i}`}>
                <span
                  className={`grid place-items-center w-9 h-9 rounded-xl shrink-0 border text-xs font-mono transition-colors duration-200 ${
                    active
                      ? "bg-primary text-[#2a2d31] border-primary"
                      : done
                      ? "bg-primary/15 text-primary border-primary/40"
                      : "bg-white/5 text-white/60 border-white/15 group-hover:border-primary/40"
                  }`}
                >
                  {Icon ? <Icon size={18} weight="duotone" /> : String(i + 1).padStart(2, "0")}
                </span>
                <div className={`text-sm font-medium ${active || done ? "text-white" : "text-white/70"}`}>{s.label}</div>
              </div>
              {i < steps.length - 1 && <CaretRight size={16} weight="bold" className="hidden sm:block text-white/25 shrink-0" aria-hidden="true" />}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
